/* /pages/ai-receptionist-for-locksmith: the AI computer window. Steps advance on their own while it is on screen, and every control works by keyboard. Without this file all steps show in order. */
(function () {
  'use strict';
  var STEP_MS = 6500;
  var TICK_MS = 100;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root) {
    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-lks-step]'));
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-lks-tab]'));
    if (!steps.length) return;
    var toggle = root.querySelector('[data-lks-toggle]');
    var rewind = root.querySelector('[data-lks-rewind]');
    var take = root.querySelector('[data-lks-takeover]');
    var banner = root.querySelector('[data-lks-banner]');
    var resume = root.querySelector('[data-lks-resume]');
    var active = 0;
    var elapsed = 0;
    var timer = null;
    var userPaused = reduce;
    var taken = false;
    var visible = false;

    function label(btn, text) { var s = btn && btn.querySelector('span'); if (s) s.textContent = text; }

    function show(i) {
      active = Math.max(0, Math.min(steps.length - 1, i));
      elapsed = 0;
      steps.forEach(function (el, n) {
        el.classList.toggle('is-active', n === active);
        el.setAttribute('aria-hidden', n === active ? 'false' : 'true');
      });
      tabs.forEach(function (el, n) {
        el.classList.toggle('is-active', n === active);
        if (n === active) el.setAttribute('aria-current', 'step'); else el.removeAttribute('aria-current');
        el.style.setProperty('--lks-p', '0');
      });
    }

    function running() { return visible && !userPaused && !taken && !document.hidden; }

    function tick() {
      if (!running()) return;
      elapsed += TICK_MS;
      var tab = tabs[active];
      if (tab) tab.style.setProperty('--lks-p', String(Math.min(1, elapsed / STEP_MS)));
      if (elapsed >= STEP_MS) {
        if (active < steps.length - 1) show(active + 1); else { userPaused = true; sync(); }
      }
    }

    function sync() {
      if (toggle) {
        toggle.setAttribute('aria-pressed', userPaused ? 'true' : 'false');
        label(toggle, userPaused ? 'Play' : 'Pause');
        var use = toggle.querySelector('use');
        if (use) use.setAttribute('href', userPaused ? '#i-play' : '#i-pause');
      }
      if (take) take.setAttribute('aria-pressed', taken ? 'true' : 'false');
      if (banner) banner.hidden = !taken;
      root.toggleAttribute('data-taken', taken);
    }

    function decide(kind) {
      var done = root.querySelector('[data-lks-done]');
      var no = root.querySelector('[data-lks-rejected]');
      root.classList.add('has-outcome');
      userPaused = true;
      sync();
      var lastDone = steps.findIndex(function (el) { return el.querySelector('[data-lks-done]'); });
      if (lastDone > -1) show(lastDone);
      if (done) done.hidden = kind !== 'approve';
      if (no) no.hidden = kind !== 'reject';
    }

    function clearOutcome() {
      var d = root.querySelector('[data-lks-done]'), n = root.querySelector('[data-lks-rejected]');
      root.classList.remove('has-outcome');
      if (d) d.hidden = false;
      if (n) n.hidden = true;
    }

    root.classList.add('is-live');
    show(0);
    sync();

    tabs.forEach(function (el) {
      el.addEventListener('click', function () {
        userPaused = true;
        clearOutcome();
        show(+el.getAttribute('data-lks-tab'));
        sync();
      });
    });
    if (toggle) toggle.addEventListener('click', function () { userPaused = !userPaused; sync(); });
    if (rewind) rewind.addEventListener('click', function () { clearOutcome(); show(0); userPaused = reduce; sync(); });
    if (take) take.addEventListener('click', function () { taken = !taken; sync(); });
    if (resume) resume.addEventListener('click', function () { taken = false; sync(); });

    root.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('[data-lks-act]') : null;
      if (!b) return;
      var act = b.getAttribute('data-lks-act');
      if (act === 'approve' || act === 'reject') decide(act);
      if (act === 'edit') { taken = true; sync(); }
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
      }, { threshold: 0.35 }).observe(root);
    } else {
      visible = true;
    }
    timer = setInterval(tick, TICK_MS);
    window.addEventListener('pagehide', function () { clearInterval(timer); });
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-lks-demo]'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
